import axios from 'axios'

// import qs from 'qs'

let env = '/'
if (window.location.href.indexOf('localhost') > 0 || window.location.href.indexOf('develop') > 0) {
  env = 'https://services.cyrela.com.br/' // produção!! admin: cms.cyrela.com.br
  //env = 'http://preproducao.services.cyrela.com.br/' // homolog admin: preproducao.ma.cyrela.com.br
  //env = 'http://develop.services.cyrela.com.br/' // develop admin: develop.ma.cyrela.com.br
}

// APIs de Cyrela (ex: Vizinhos de obra)
let formDrupal = '/'
if (window.location.href.indexOf('localhost') > 0) {
  formDrupal = 'http://cyrela.lndo.site'
} else if (window.location.href.indexOf('develop') > 0) {
  formDrupal = 'https://develop-cyrela.pantheonsite.io'
} else {
  // produção
  formDrupal = 'https://www.cyrela.com.br'
}


const HTTP = axios.create({
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
  baseURL: env,
})


const HTTP_FORM = axios.create({
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
  baseURL: formDrupal,
})

const WHATSAPP_MASK_API = axios.create({
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
  baseURL: formDrupal + '/api/whatsapp-lead',
})

// Rever esse trecho, está conflitante
const XIOS = axios.create({
  withCredentials: false,
  headers: {
    'Content-type': 'application/x-www-form-urlencoded',
    'content-type': 'multipart/form-data',
  },
  baseURL: env,
})


export { HTTP, XIOS, HTTP_FORM, WHATSAPP_MASK_API }



// WEBPACK FOOTER //
// ./src/api/http-common.js